import React, { Fragment } from "react";
import { ImFacebook2 } from "react-icons/im";
import { ImLinkedin } from "react-icons/im";
import { ImTwitter } from "react-icons/im";
import { ImYoutube } from "react-icons/im";
import { useFormInputValidation } from "react-form-input-validation";
import "react-notifications/lib/notifications.css";
import {
  NotificationContainer,
  NotificationManager,
} from "react-notifications";

import { Base_URL } from "../BaseURL";
let ContactIconImgs = [
  "https://ezmarketingtech.s3.amazonaws.com/img/open-email.png",
  "https://ezmarketingtech.s3.amazonaws.com/img/smartphone2.png",
  "https://ezmarketingtech.s3.amazonaws.com/img/location.png",
];
function ContactForm() {
  const [fields, errors, form] = useFormInputValidation(
    {
      customer_name: "Name",
      email_address: "Email address",
      phone_number: "Phone number",
    },
    {
      customer_name: "required",
      email_address: "required|email",
      phone_number: "required|numeric|digits_between:10,12",
    }
  );

  const onSubmit = (type, event) => {
    return () => {
      switch (type) {
        case "success":
          NotificationManager.success("Successfully Submitted");
          break;
        default:
          event.preventDefault();
      }
    };
  };

  return (
    <Fragment>
      <section className="rs-contact style2">
        <div className="container">
          <h1 className="all_main_heading ">Contact Our Team</h1>
          <p className="all_main_discription">
            Connect with EZ Marketing Agency for Your Digital Marketing Services
            Needs
          </p>
          <div className="row">
            <div className="col-lg-4 mb-5">
              <div className="contact-box">
                <div className="sec-title mb-3">
                  <h2 className="title title4">
                    Talk With Our Expert Advisors
                  </h2>
                </div>
                <div className="address-box mb-3">
                  <div className="address-img">
                    <img src={ContactIconImgs[0]} alt="images" />
                  </div>
                  <div className="address-text">
                    <span className="label">Email</span>
                    <a href="mailto:sales@ezmarketing.agency">
                    sales@ezmarketing.agency
                    </a>
                  </div>
                </div>
                <div className="address-box mb-3">
                  <div className="address-img">
                    <img src={ContactIconImgs[1]} alt="images" />
                  </div>
                  <div className="address-text">
                    <span className="label">Call Us</span>
                    <a href="tel:+1 (855) 781-2099">+1 (855) 781-2099</a>
                  </div>
                </div>
                <div className="address-box mb-5">
                  <div className="address-img">
                    <img src={ContactIconImgs[2]} alt="images" />
                  </div>
                  <div className="address-text">
                    <span className="label">Office Address</span>
                    <div className="desc">
                      EZ Marketing Agency
                      <br />
                      8605 Santa Monica,
                      <br />
                      Blvd #15749,West Hollywood,
                      <br />
                      California 90069-4109 US
                    </div>
                  </div>
                </div>
                <ul className="social-icon pt-60">
                  <li>
                    <a
                      href="https://www.facebook.com/ezmarketingagencyusa/"
                      target="_blank"
                      rel="noreferrer"
                    >
                      <span>
                        <ImFacebook2 />
                      </span>
                    </a>
                  </li>
                  <li>
                    <a
                      className="paste-bg"
                      href="https://twitter.com/EzmarketingUsa "
                      target="_blank"
                      rel="noreferrer"
                    >
                      <span>
                        <ImTwitter />
                      </span>
                    </a>
                  </li>

                  <li>
                    <a
                      className="pink-bg"
                      href="https://www.youtube.com/channel/UCU1DcAmBpnswfX88X3E7XTA "
                      target="_blank"
                      rel="noreferrer"
                    >
                      <span>
                        <ImYoutube />
                      </span>
                    </a>
                  </li>
                  <li>
                    <a
                      className="black-bg"
                      href="https://www.linkedin.com/company/ez-marketing-tech"
                      target="_blank"
                      rel="noreferrer"
                    >
                      <span>
                        <ImLinkedin />
                      </span>
                    </a>
                  </li>
                </ul>
              </div>
            </div>
            <div className="col-lg-8 pl-35 md-pl-15">
              <div className="contact-widget">
                <div className="sec-title2 mb-40">
                  <span className="sub-text contact mb-15">Get In Touch</span>
                  <h2 className="title">Fill The Form Below</h2>
                </div>
                <div id="form-messages"></div>
                <form
                  id="contact-form"
                  action={`${Base_URL}/mail`}
                  method="POST"
                  onSubmit={onSubmit("success")}
                  Validate
                  autoComplete="off"
                  
                >
                  <fieldset>
                    <div className="row">
                      <input
                        className="from-control"
                        type="hidden"
                        id="key"
                        name="key"
                        value="contact_us"
                      />

                      <div className="col-lg-6 mb-3 col-md-6 col-sm-6">
                        <input
                          className="from-control"
                          type="text"
                          id="name"
                          name="name"
                          onBlur={form.handleBlurEvent}
                          onChange={form.handleChangeEvent}
                          placeholder={fields.customer_name}
                          required={true}
                        />
                        <span className="error alert-danger">
                          {errors.customer_name ? errors.customer_name : ""}
                        </span>
                      </div>
                      <div className="col-lg-6 mb-3 col-md-6 col-sm-6">
                        <input
                          className="from-control"
                          type="email"
                          id="email"
                          name="email"
                          onBlur={form.handleBlurEvent}
                          onChange={form.handleChangeEvent}
                          placeholder={fields.email_address}
                          required={true}
                        />
                        <span className="error alert-danger">
                          {errors.email_address ? errors.email_address : ""}
                        </span>
                      </div>
                      <div className="col-lg-6 mb-3 col-md-6 col-sm-6">
                        <input
                          className="from-control"
                          type="tel"
                          id="phone"
                          name="phone"
                          onBlur={form.handleBlurEvent}
                          onChange={form.handleChangeEvent}
                          placeholder={fields.phone_number}
                          pattern="\+?[0-9]+"
                          required={true}
                        />
                        <span className="error alert-danger">
                          {errors.phone_number ? errors.phone_number : ""}
                        </span>
                      </div>
                      <div className="col-lg-6 mb-3 col-md-6 col-sm-6">
                        <input
                          className="from-control"
                          type="text"
                          id="subject"
                          name="subject"
                          placeholder="Your Website"
                         
                          required={true}
                        />
                      </div>

                      <div className="col-lg-12 mb-3">
                        <textarea
                          className="from-control"
                          id="message"
                          name="message"
                          placeholder="Your Message"
                          required={true}
                        ></textarea>
                      </div>
                    </div>
                    <NotificationContainer />
                    <div className="btn-part">
                      <div className="form-group recaptcha_group mb-0">
                        {/* <ReCAPTCHA
                          sitekey="6Lfq_EkpAAAAADbKFetA0lEpOX48FSsJGTeW2kSq"
                          onChange={setTimeout(onChange, 2000)}
                          className="recaptcha"
                          ref={captchaRef}
                        /> */}
                        <button
                          // disabled={!isCaptchaSuccessful}
                          className="readon submit new"
                        >
                          Submit Now
                        </button>
                      </div>
                    </div>
                  </fieldset>
                </form>
              </div>
            </div>
          </div>
        </div>
        <div className="map-canvas pt-120 md-pt-80">
          <iframe
            src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d13217.100802047944!2d-118.3794525!3d34.0880898!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x80c2bbfe61556ac5%3A0x89f85f7bd9347997!2sEZ%20Marketing%20Tech!5e0!3m2!1sen!2sin!4v1680607543917!5m2!1sen!2sin"
            width="100%"
            height="550"
            title="map"
            allowfullscreen=""
            referrerpolicy="no-referrer-when-downgrade"
          >
            digital marketing agency,seo services,seo, seo services near me
          </iframe>
        </div>
      </section>
    </Fragment>
  );
}

export default ContactForm;
